export default __webpack_public_path__ + "static/media/game-pagetype-home_game.26596ddc.svg";